module.exports = __webpack_public_path__ + "static/media/typeService.e16f040a.svg";